function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Website Analytics › drill-in views (spec §4): Acquisition · Pages · Products · Places.
 * Tables are the shared .territory-table; CSV exports reuse the legacy metric
 * export routes. Phase 2: channels, landing pages and entrances/exits come from the
 * server (metrics/channels, metrics/landing, metrics/page/flow) with the phase-1
 * client-side derivations as the fallback when an endpoint is absent.
 */
import React from "react";
import { HBars } from "./charts";
import { Pending, Phase, Ribbon, Card, Search, Filters, coverageNote as prevNote } from "../../components/analytics-kit";
import { num, usd, deltaOf } from "../sales/territory-common";
import PostalBubbleMap from "../market-intelligence/postal-bubble-map";
import GeoChoropleth from "../../components/geo-choropleth";
import ChartBoundary from "../market-intelligence/chart-boundary";
import { countAxis } from "../../components/chart";
import { Chart, ChartSeries, ChartSeriesItem, ChartCategoryAxis, ChartCategoryAxisItem, ChartValueAxis, ChartValueAxisItem, ChartTooltip } from "@progress/kendo-react-charts";
import { Link } from "react-router-dom";
import PlunkDropDown from "../../components/plunk-dropdown";
import { getUtm, getPages, getPageScorecard, getProducts, getLocations, getPlaces, getChannels, getLanding, getPageFlow, getActivityData, getHosts, getHostPages, getSeries, seriesCoverage, seriesRows, previousPreset, safe, channelsFromUtm, channelsFromServer, channelOf, channelLabel, landingIndex, fmtDuration, pctOf } from "./data";
import { pathOf } from "./overview";

// ---------------------------------------------------------------- Acquisition
export class Acquisition extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      utm: undefined,
      channels: undefined,
      landing: undefined,
      act: undefined,
      q: "",
      groupBy: "source"
    });
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(p) {
    if (p.range !== this.props.range) this.load();
  }
  async load() {
    this.setState({
      utm: undefined,
      channels: undefined,
      landing: undefined,
      act: undefined
    });
    safe(getActivityData(this.props.range)).then(a => this.setState({
      act: a || null
    }));
    safe(getChannels(this.props.range)).then(r => this.setState({
      channels: r && r.rows ? r : null
    }));
    safe(getLanding(this.props.range)).then(r => this.setState({
      landing: r && r.rows ? landingIndex(r) : null
    }));
    const r = await safe(getUtm(this.props.range, {
      top: 500
    }));
    this.setState({
      utm: r ? r.items : null
    });
  }
  render() {
    const {
      utm,
      channels,
      landing,
      act,
      q,
      groupBy
    } = this.state;
    const {
      range
    } = this.props;
    const rows = (utm || []).filter(r => !q || `${r.source} ${r.medium} ${r.campaign}`.toLowerCase().includes(q.toLowerCase()));
    const grouped = groupBy === "channel" ? groupRows(rows, r => channelOf(r)) : groupBy === "medium" ? groupRows(rows, r => `${r.source || "(direct)"} / ${r.medium || "(none)"}`) : rows;
    const chLoading = channels === undefined || channels === null && utm === undefined;
    const chList = channels ? channelsFromServer(channels) : channelsFromUtm(utm);
    const channelBars = chList.map(c => ({
      name: c.channel,
      value: c.sessions,
      right: `${pctOf(c.conversions, c.sessions).toFixed(1)}%`
    }));
    const landingFor = r => {
      if (!landing) return null;
      const hit = landing[`${(r.source || "").toLowerCase()}|${(r.medium || "").toLowerCase()}`];
      return hit ? hit.path : null;
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "wa-grid"
    }, renderActivitySections(act, range), /*#__PURE__*/React.createElement(Card, {
      title: "Channels",
      hint: "sessions \xB7 users \xB7 conversions \xB7 interactions",
      span: channels ? 6 : 12
    }, chLoading ? /*#__PURE__*/React.createElement(Pending, null) : !chList.length ? /*#__PURE__*/React.createElement("div", {
      className: "wa-empty"
    }, "No sessions in this range.") : (() => {
      const max = Math.max(1, ...chList.map(c => c.sessions));
      const tot = chList.reduce((a, c) => a + c.sessions, 0);
      return /*#__PURE__*/React.createElement("div", {
        className: "tblwrap"
      }, /*#__PURE__*/React.createElement("table", {
        className: "territory-table wa-table wa-channels"
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Channel"), /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "Sessions"), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "Users"), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "Conv."), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "Rate"), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "Interactions"), /*#__PURE__*/React.createElement("th", {
        className: "n"
      }, "Value"))), /*#__PURE__*/React.createElement("tbody", null, chList.map(c => /*#__PURE__*/React.createElement("tr", {
        key: c.channel
      }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("b", null, c.channel)), /*#__PURE__*/React.createElement("td", {
        className: "bar"
      }, /*#__PURE__*/React.createElement("span", {
        className: "track"
      }, /*#__PURE__*/React.createElement("i", {
        style: {
          width: `${(c.sessions / max * 100).toFixed(1)}%`
        }
      }))), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, num(c.sessions), " ", /*#__PURE__*/React.createElement("small", {
        className: "dim"
      }, tot ? `${(c.sessions / tot * 100).toFixed(0)}%` : "")), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, num(c.users)), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, num(c.conversions)), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, pctOf(c.conversions, c.sessions).toFixed(1), "%"), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, num(c.engagements)), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, Number(c.value) > 0 ? usd(c.value) : "—"))))));
    })(), channels && channels.truncated ? /*#__PURE__*/React.createElement("div", {
      className: "foot"
    }, "Window clamped to the last 400 days.") : null), channels ? /*#__PURE__*/React.createElement(Card, {
      title: "Top sources by channel",
      hint: "first page of the session",
      span: 6
    }, /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Channel"), /*#__PURE__*/React.createElement("th", null, "Source"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Sessions"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Users"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Conv."), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Rate"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Interactions"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Value"))), /*#__PURE__*/React.createElement("tbody", null, (channels.rows || []).slice(0, 12).map((r, i) => /*#__PURE__*/React.createElement("tr", {
      key: i
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("b", null, channelLabel(r.channel))), /*#__PURE__*/React.createElement("td", {
      className: "dim"
    }, r.source || "(direct)", r.medium ? /*#__PURE__*/React.createElement("span", {
      className: "path"
    }, "/ ", r.medium) : null), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.sessions)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.users)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.conversions)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, pctOf(r.conversions, r.sessions).toFixed(1), "%"), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.engagements)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, Number(r.value) > 0 ? usd(r.value) : "—"))))))) : null, /*#__PURE__*/React.createElement(Card, {
      title: "Sources",
      hint: "source \u203A medium \u203A campaign",
      right: /*#__PURE__*/React.createElement("a", {
        href: `#`,
        onClick: e => {
          e.preventDefault();
          exportCsv(`/metrics/utmexport/${range}`, `utm-${range}.csv`);
        }
      }, "Export CSV")
    }, /*#__PURE__*/React.createElement("div", {
      className: "wa-toolbar"
    }, /*#__PURE__*/React.createElement("span", {
      className: "seg"
    }, [["source", "Rows"], ["medium", "Source / medium"], ["channel", "Channel"]].map(([k, l]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      className: groupBy === k ? "on" : "",
      onClick: () => this.setState({
        groupBy: k
      })
    }, l))), /*#__PURE__*/React.createElement("span", {
      className: "wa-filters"
    }, /*#__PURE__*/React.createElement(Search, {
      value: q,
      onChange: v => this.setState({
        q: v
      }),
      placeholder: "Search source, medium, campaign"
    }))), utm === undefined ? /*#__PURE__*/React.createElement(Pending, null) : !rows.length ? /*#__PURE__*/React.createElement("div", {
      className: "wa-empty"
    }, "No sessions with a source in this range.") : /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, groupBy === "channel" ? "Channel" : "Source"), groupBy === "source" ? /*#__PURE__*/React.createElement("th", null, "Medium") : null, groupBy === "source" ? /*#__PURE__*/React.createElement("th", null, "Campaign") : null, /*#__PURE__*/React.createElement("th", null, "Landing page", landing ? null : /*#__PURE__*/React.createElement(Phase, null)), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Users"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Sessions"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Conv."), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Rate"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Interactions"))), /*#__PURE__*/React.createElement("tbody", null, grouped.slice(0, 100).map((r, i) => /*#__PURE__*/React.createElement("tr", {
      key: i
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("b", null, groupBy === "channel" ? r.key : r.source || "(direct)")), groupBy === "source" ? /*#__PURE__*/React.createElement("td", null, r.medium || "(none)") : null, groupBy === "source" ? /*#__PURE__*/React.createElement("td", null, r.campaign || "—") : null, /*#__PURE__*/React.createElement("td", {
      className: "dim"
    }, groupBy === "source" && landingFor(r) ? /*#__PURE__*/React.createElement("span", {
      title: landingFor(r)
    }, landingFor(r)) : "—"), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.users)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.sessions)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.conversions)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, pctOf(r.conversions, r.sessions).toFixed(1), "%"), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.engagements))))))), /*#__PURE__*/React.createElement("div", {
      className: "foot"
    }, landing ? "Landing page = the most common first page for that source and medium." : "Channel = UTM medium, then the source host.")));
  }
}
function groupRows(rows, keyFn) {
  const acc = {};
  rows.forEach(r => {
    const k = keyFn(r);
    const a = acc[k] || (acc[k] = {
      key: k,
      source: k,
      users: 0,
      sessions: 0,
      conversions: 0,
      engagements: 0
    });
    a.users += Number(r.users) || 0;
    a.sessions += Number(r.sessions) || 0;
    a.conversions += Number(r.conversions) || 0;
    a.engagements += Number(r.engagements) || 0;
  });
  return Object.values(acc).sort((a, b) => b.sessions - a.sessions);
}

// ---------------------------------------------------------------- Pages
export class Pages extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      pages: undefined,
      total: null,
      card: null,
      prevCard: undefined,
      series: undefined,
      prevSeries: undefined,
      flow: undefined,
      hostMap: null,
      q: "",
      site: "",
      metric: "views",
      min: "",
      sort: "Views"
    });
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(p) {
    if (p.range !== this.props.range || p.sort !== this.props.sort) this.load();
  }
  async load() {
    this.setState({
      pages: undefined,
      flow: undefined,
      prevCard: undefined,
      series: undefined,
      prevSeries: undefined
    });
    const prevRange = previousPreset(this.props.range);
    safe(getSeries(this.props.range)).then(r => this.setState({
      series: r && r.points ? r : null
    }));
    if (prevRange) {
      safe(getPageScorecard(prevRange)).then(c => this.setState({
        prevCard: c || null
      }));
      safe(getSeries(prevRange)).then(r => this.setState({
        prevSeries: r && r.points ? r : null
      }));
    } else this.setState({
      prevCard: null,
      prevSeries: null
    });
    safe(getPageFlow(this.props.range)).then(f => {
      const idx = {};
      (f && f.rows || []).forEach(x => {
        idx[x.path] = x;
      });
      this.setState({
        flow: f && f.rows ? idx : null
      });
    });
    // Page rows carry a path, not a host: map path → host through the per-host page lists so each row links to its live page.
    safe(getHosts(this.props.range)).then(async h => {
      const hosts = (h && h.hosts || []).map(x => x.host).filter(x => x && !/^app:/i.test(x));
      const map = {};
      const best = {};
      await Promise.all(hosts.slice(0, 6).map(async host => {
        const r = await safe(getHostPages(this.props.range, host));
        (r && r.pages || []).forEach(pg => {
          const k = pg.path || pg.url;
          const v = Number(pg.views) || 0;
          if (k && (best[k] == null || v > best[k])) {
            best[k] = v;
            map[k] = host;
          }
        });
      }));
      if (hosts.length === 1) map.__only = hosts[0];
      this.setState({
        hostMap: map
      });
    });
    const [r, card] = await Promise.all([safe(getPages(this.props.range, {
      top: 200,
      orderByDesc: this.state.sort
    })), safe(getPageScorecard(this.props.range))]);
    this.setState({
      pages: r ? r.items : null,
      total: r && r.pagination ? Number(r.pagination.count) || null : null,
      card: card || null
    });
  }
  setSort(s) {
    this.setState({
      sort: s
    }, () => this.load());
  }
  render() {
    const {
      pages,
      total,
      card,
      prevCard,
      series,
      prevSeries,
      flow,
      q,
      sort
    } = this.state;
    const {
      range
    } = this.props;
    const flowOf = p => flow ? flow[pathOf(p.url)] || flow[p.url] : null;
    const {
      site,
      metric,
      min,
      hostMap
    } = this.state;
    const hostFor = p => p.host || hostOf(p.url) || (hostMap ? hostMap[pathOf(p.url)] || hostMap[p.url] || hostMap.__only || "" : "");
    const hosts = Array.from(new Set((pages || []).map(p => hostFor(p)).filter(Boolean))).sort();
    const metricOf = p => metric === "exitRate" ? flowOf(p) ? Number(flowOf(p).exitRate) * 100 : 0 : metric === "entrances" ? flowOf(p) ? Number(flowOf(p).entrances) : 0 : metric === "avgTimeSpan" ? Number(p.avgTimeSpan) || 0 : Number(p[metric]) || 0;
    const rows = (pages || []).filter(p => (!q || `${p.title} ${p.url}`.toLowerCase().includes(q.toLowerCase())) && (!site || hostFor(p) === site) && (min === "" || metricOf(p) >= Number(min)));
    const shown = rows.slice(0, 50);
    const tot = k => rows.reduce((s, r) => s + (Number(r[k]) || 0), 0);
    // Ribbon = the range scorecard (all pages), not the loaded top-N.
    const kp = (k, fallback) => card && card[k] != null ? Number(card[k]) : fallback;
    const pagesTotal = kp("totalPages", total || rows.length);
    return /*#__PURE__*/React.createElement("div", null, (() => {
      const partialNote = prevNote(prevSeries);
      const usePrev = prevCard && !partialNote;
      const comparing = prevCard === undefined || prevSeries === undefined ? undefined : !!usePrev;
      const d = (cur, k) => usePrev && prevCard[k] != null ? deltaOf(cur, Number(prevCard[k])) : null;
      const sr = series ? seriesRows(series) : [];
      const views = kp("views", tot("views")),
        sessions = kp("sessions", tot("sessions")),
        users = kp("uniqueUsers", tot("uniqueUsers"));
      const tiles = [{
        l: "Pages with views",
        v: num(pagesTotal),
        d: d(pagesTotal, "totalPages"),
        s: sr.length ? `${num(Math.round(views / Math.max(1, sr.length)))} views per day` : null
      }, {
        l: "Views",
        v: num(views),
        d: d(views, "views"),
        s: sessions ? `${(views / sessions).toFixed(1)} per session` : null,
        sp: sr.map(r => r.views)
      }, {
        l: "Sessions",
        v: num(sessions),
        d: d(sessions, "sessions"),
        s: users ? `${(sessions / users).toFixed(1)} per user` : null,
        sp: sr.map(r => r.sessions)
      }, {
        l: "Users",
        v: num(users),
        d: d(users, "uniqueUsers"),
        s: card && card.avgTimeSpan ? `${fmtDuration(card.avgTimeSpan)} avg time on page` : null,
        sp: sr.map(r => r.users)
      }];
      return /*#__PURE__*/React.createElement(Ribbon, {
        tiles: tiles,
        comparing: comparing,
        note: partialNote,
        loading: pages === undefined
      });
    })(), /*#__PURE__*/React.createElement("div", {
      className: "wa-grid"
    }, /*#__PURE__*/React.createElement(Card, {
      title: "Pages",
      hint: pages ? rows.length > 50 ? `top 50 of ${num(rows.length)} loaded · narrow with search or filters` : `${num(rows.length)} pages` : "",
      right: /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: e => {
          e.preventDefault();
          exportCsv(`/metrics/export/${range}`, `activity-${range}.csv`);
        }
      }, "Export CSV")
    }, /*#__PURE__*/React.createElement("div", {
      className: "wa-toolbar"
    }, /*#__PURE__*/React.createElement("span", {
      className: "seg"
    }, [["Views", "Views"], ["Sessions", "Sessions"], ["UniqueUsers", "Users"], ["AvgTimeSpan", "Time on page"]].map(([k, l]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      className: sort === k ? "on" : "",
      onClick: () => this.setSort(k)
    }, l))), /*#__PURE__*/React.createElement("span", {
      className: "wa-filters"
    }, /*#__PURE__*/React.createElement(Search, {
      value: q,
      onChange: v => this.setState({
        q: v
      }),
      placeholder: "Search path or title"
    }), hosts.length > 1 ? /*#__PURE__*/React.createElement(PlunkDropDown, {
      options: [["", "All sites"]].concat(hosts.map(h => [h, h])),
      value: site,
      onChange: v => this.setState({
        site: v
      }),
      width: "180px"
    }) : null, /*#__PURE__*/React.createElement(PlunkDropDown, {
      options: [["views", "Views"], ["sessions", "Sessions"], ["uniqueUsers", "Users"], ["avgTimeSpan", "Avg time (s)"], ["entrances", "Entrances"], ["exitRate", "Exit rate %"]],
      value: metric,
      onChange: v => this.setState({
        metric: v
      }),
      width: "150px"
    }), /*#__PURE__*/React.createElement("input", {
      className: "cust-search wa-select",
      style: {
        width: 110
      },
      type: "number",
      min: "0",
      value: min,
      placeholder: "at least\u2026",
      onChange: e => this.setState({
        min: e.target.value
      })
    }), q || site || min !== "" ? /*#__PURE__*/React.createElement("button", {
      className: "wa-chip",
      onClick: () => this.setState({
        q: "",
        site: "",
        min: ""
      })
    }, "Clear filters") : null)), pages === undefined ? /*#__PURE__*/React.createElement(Pending, null) : !rows.length ? /*#__PURE__*/React.createElement("div", {
      className: "wa-empty"
    }, "No pages match.") : /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Page"), /*#__PURE__*/React.createElement("th", null, "Site"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Views"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Sessions"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Users"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Avg time"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Entrances", flow ? null : /*#__PURE__*/React.createElement(Phase, null)), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Exit rate", flow ? null : /*#__PURE__*/React.createElement(Phase, null)), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", null, shown.map(p => /*#__PURE__*/React.createElement("tr", {
      key: p.url
    }, /*#__PURE__*/React.createElement("td", {
      className: "wa-page"
    }, (() => {
      // No page title: show the path once (it used to print the path as the
      // name and again as the grey path, e.g. "/ /").
      const path = pathOf(p.url) || p.url;
      const title = (p.title || "").trim();
      const hasTitle = title && title !== p.url && title !== path;
      const name = /*#__PURE__*/React.createElement("b", null, hasTitle ? title : path);
      const href = liveHref(p, hostFor(p));
      return /*#__PURE__*/React.createElement(React.Fragment, null, href ? /*#__PURE__*/React.createElement("a", {
        href: href,
        target: "_blank",
        rel: "noopener noreferrer",
        title: "Open the live page"
      }, name) : name, hasTitle ? /*#__PURE__*/React.createElement("span", {
        className: "dim path"
      }, path) : null);
    })()), /*#__PURE__*/React.createElement("td", {
      className: "dim"
    }, hostFor(p)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(p.views)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(p.sessions)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(p.uniqueUsers)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, p.avgTimeSpanString || (p.avgTimeSpan ? fmtDuration(p.avgTimeSpan) : "—")), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, flowOf(p) ? num(flowOf(p).entrances) : /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, "\u2014")), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, flowOf(p) ? `${(Number(flowOf(p).exitRate) * 100).toFixed(0)}%` : /*#__PURE__*/React.createElement("span", {
      className: "dim"
    }, "\u2014")), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, /*#__PURE__*/React.createElement(Link, {
      className: "wa-rowlink",
      to: `/Activity/Heat/${range}?page=${encodeURIComponent(`${p.host || hostOf(p.url)}|${pathOf(p.url)}`)}`,
      title: "Open this page's heat map"
    }, "Heat \u2192"))))))))));
  }
}
function hostOf(url) {
  try {
    return new URL(url).host;
  } catch (e) {
    return "";
  }
}
// Same rule as the legacy Pages tab: absolute urls open as-is, paths open on the row's host (app: hosts are not web pages).
function liveHref(p, host) {
  if (/^https?:/i.test(p.url || "")) return p.url;
  const h = host || p.host || "";
  return h && !/^app:/i.test(h) ? `https://${h}${p.url}` : null;
}

// ---------------------------------------------------------------- Products
export class Products extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      products: undefined,
      prev: undefined,
      prevSeries: undefined,
      series: undefined,
      q: "",
      sort: "Views"
    });
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(p) {
    if (p.range !== this.props.range) this.load();
  }
  async load() {
    this.setState({
      products: undefined,
      prev: undefined,
      prevSeries: undefined,
      series: undefined
    });
    safe(getSeries(this.props.range, null, "products")).then(r => this.setState({
      series: r && r.points ? r : null
    }));
    const prevRange = previousPreset(this.props.range);
    if (prevRange) Promise.all([safe(getProducts(prevRange, {
      top: 200
    })), safe(getSeries(prevRange))]).then(([pp, ps]) => this.setState({
      prev: pp && pp.items ? pp.items : null,
      prevSeries: ps && ps.points ? ps : null
    }));else this.setState({
      prev: null,
      prevSeries: null
    });
    const r = await safe(getProducts(this.props.range, {
      top: 200,
      orderByDesc: this.state.sort
    }));
    this.setState({
      products: r ? r.items : null
    });
  }
  setSort(s) {
    this.setState({
      sort: s
    }, () => this.load());
  }
  render() {
    const {
      products,
      prev,
      prevSeries,
      series,
      q,
      sort
    } = this.state;
    const {
      range
    } = this.props;
    const ps = series ? seriesRows(series) : [];
    const pe = series ? (series.points || []).map(p => Number(p.engagements) || 0) : [];
    const sums = list => {
      const t = {
        products: 0,
        views: 0,
        users: 0,
        conversions: 0,
        engagements: 0,
        value: 0
      };
      (list || []).forEach(p => {
        if ((Number(p.views) || 0) > 0) t.products += 1;
        t.views += Number(p.views) || 0;
        t.users += Number(p.uniqueUsers) || 0;
        t.conversions += Number(p.conversions) || 0;
        t.engagements += Number(p.engagements) || 0;
        t.value += Number(p.conversionsValue || p.value) || 0;
      });
      return t;
    };
    const cur = sums(products);
    const pv = prev ? sums(prev) : null;
    const partialNote = prevNote(prevSeries);
    const usePrev = pv && !partialNote;
    const comparing = prev === undefined || prevSeries === undefined ? undefined : !!usePrev;
    const d = k => usePrev ? deltaOf(cur[k], pv[k]) : null;
    const rows = (products || []).filter(p => !q || `${p.title} ${p.productId}`.toLowerCase().includes(q.toLowerCase()));
    const top = rows.slice(0, 10);
    const max = Math.max(1, ...top.map(p => Number(p.views) || 0));
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Ribbon, {
      loading: products === undefined,
      comparing: comparing,
      note: partialNote,
      tiles: [{
        l: "Products viewed",
        v: num(cur.products),
        d: d("products"),
        s: products ? `of ${num(products.length)} with activity` : null,
        sp: ps.map(r => r.users)
      }, {
        l: "Product views",
        v: num(cur.views),
        d: d("views"),
        s: cur.users ? `${(cur.views / cur.users).toFixed(1)} per user` : null,
        sp: ps.map(r => r.views)
      }, {
        l: "Conversions",
        v: num(cur.conversions),
        d: d("conversions"),
        s: cur.views ? `${pctOf(cur.conversions, cur.views).toFixed(1)}% of views` : null,
        sp: ps.map(r => r.conversions)
      }, {
        l: "Interactions",
        v: num(cur.engagements),
        d: d("engagements"),
        s: cur.value > 0 ? `${usd(cur.value)} value` : null,
        sp: pe
      }]
    }), /*#__PURE__*/React.createElement("div", {
      className: "wa-grid"
    }, /*#__PURE__*/React.createElement(Card, {
      title: "Top 10 products",
      hint: sort === "Views" ? "views" : sort.toLowerCase()
    }, /*#__PURE__*/React.createElement("div", {
      className: "wa-toolbar"
    }, /*#__PURE__*/React.createElement("span", {
      className: "seg"
    }, [["Views", "Views"], ["Conversions", "Conversions"], ["Engagements", "Interactions"]].map(([k, l]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      className: sort === k ? "on" : "",
      onClick: () => this.setSort(k)
    }, l)))), products === undefined ? /*#__PURE__*/React.createElement(Pending, null) : !top.length ? /*#__PURE__*/React.createElement("div", {
      className: "wa-empty"
    }, "No product views in this range.") : (() => {
      const key = sort === "Views" ? "views" : sort === "Conversions" ? "conversions" : "engagements";
      const label = sort === "Views" ? "Views" : sort === "Conversions" ? "Conversions" : "Interactions";
      if (!top.some(p => (Number(p[key]) || 0) > 0)) return /*#__PURE__*/React.createElement("div", {
        className: "wa-empty"
      }, "No product ", label.toLowerCase(), " recorded in this range. ", sort === "Conversions" ? "Product conversions count when a conversion fires on a product page; checkout on another site (Stripe, Shopify) is attributed to the site, not the product." : "Interactions count clicks and engagements fired on a product page.");
      // The legacy Products tab's column chart (Kendo), on the dashboard's chart color; transitions off per the React 16 tooltip loop.
      return /*#__PURE__*/React.createElement(ChartBoundary, null, /*#__PURE__*/React.createElement(Chart, {
        transitions: false,
        style: {
          height: 320
        }
      }, /*#__PURE__*/React.createElement(ChartCategoryAxis, null, /*#__PURE__*/React.createElement(ChartCategoryAxisItem, {
        categories: top.map(p => p.title || p.productId || ""),
        labels: {
          rotation: -45,
          font: "11px Proxima Nova, sans-serif",
          color: "#666",
          content: e => {
            const parts = String(e.value).split(" ");
            if (parts.length <= 2) return e.value;
            const mid = Math.ceil(parts.length / 2);
            return parts.slice(0, mid).join(" ") + "\n" + parts.slice(mid).join(" ");
          }
        },
        majorGridLines: {
          visible: false
        }
      })), /*#__PURE__*/React.createElement(ChartValueAxis, null, /*#__PURE__*/React.createElement(ChartValueAxisItem, _extends({}, countAxis(top.map(p => Number(p[key]) || 0)), {
        labels: {
          format: "{0:n0}",
          font: "11px Proxima Nova, sans-serif",
          color: "#888"
        },
        majorGridLines: {
          color: "#eceff3"
        },
        line: {
          visible: false
        }
      }))), /*#__PURE__*/React.createElement(ChartSeries, null, /*#__PURE__*/React.createElement(ChartSeriesItem, {
        type: "column",
        data: top.map(p => Number(p[key]) || 0),
        name: label,
        color: "#378add",
        gap: 1.2,
        labels: {
          visible: true,
          position: "top",
          font: "11px Proxima Nova, sans-serif",
          content: e => num(e.value)
        }
      })), /*#__PURE__*/React.createElement(ChartTooltip, {
        render: e => e && e.point ? `${e.point.category}: ${num(e.point.value)} ${label.toLowerCase()}` : ""
      })));
    })()), /*#__PURE__*/React.createElement(Card, {
      title: "Products",
      hint: products ? `${num(rows.length)} with activity` : "",
      right: /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: e => {
          e.preventDefault();
          exportCsv(`/metrics/product-performance/export/${range}`, `products-${range}.csv`);
        }
      }, "Export CSV")
    }, /*#__PURE__*/React.createElement("div", {
      className: "wa-toolbar"
    }, /*#__PURE__*/React.createElement(Search, {
      value: q,
      onChange: v => this.setState({
        q: v
      }),
      placeholder: "Search title or SKU"
    })), products === undefined ? /*#__PURE__*/React.createElement(Pending, null) : !rows.length ? null : /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Product"), /*#__PURE__*/React.createElement("th", null, "SKU"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Views"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Users"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Interactions"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Conv."), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Rate"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Value"))), /*#__PURE__*/React.createElement("tbody", null, rows.slice(0, 200).map(p => /*#__PURE__*/React.createElement("tr", {
      key: p.productId || p.title
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "prow"
    }, p.imageLink ? /*#__PURE__*/React.createElement("img", {
      className: "thumb",
      src: p.imageLink,
      alt: "",
      loading: "lazy"
    }) : /*#__PURE__*/React.createElement("span", {
      className: "thumb"
    }), /*#__PURE__*/React.createElement("b", null, p.link ? /*#__PURE__*/React.createElement("a", {
      href: p.link,
      target: "_blank",
      rel: "noopener noreferrer"
    }, p.title) : p.title))), /*#__PURE__*/React.createElement("td", {
      className: "dim"
    }, p.productId), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(p.views)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(p.uniqueUsers)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(p.engagements)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(p.conversions)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, pctOf(p.conversions, p.views).toFixed(1), "%"), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, Number(p.conversionsPriceValue) > 0 ? usd(p.conversionsPriceValue) : "—")))))))));
  }
}

// ---------------------------------------------------------------- Places
export class Places extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      locations: undefined,
      places: undefined,
      cities: null,
      prev: undefined,
      prevSeries: undefined,
      geoSeries: undefined,
      marketSeries: undefined,
      mode: "us",
      markets: true,
      hovered: null,
      q: "",
      country: ""
    });
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(p) {
    if (p.range !== this.props.range) this.load();
  }
  async load() {
    this.setState({
      locations: undefined,
      places: undefined,
      prev: undefined,
      prevSeries: undefined,
      geoSeries: undefined,
      marketSeries: undefined
    });
    safe(getSeries(this.props.range, null, "places")).then(r => this.setState({
      geoSeries: r && r.points ? r : null
    }));
    safe(getSeries(this.props.range, null, "markets")).then(r => this.setState({
      marketSeries: r && r.points ? r : null
    }));
    const prevRange = previousPreset(this.props.range);
    if (prevRange) {
      Promise.all([safe(getLocations(prevRange, "city", {
        top: 200
      })), safe(getPlaces(prevRange, {
        top: 100
      })), safe(getSeries(prevRange))]).then(([pl, pp, ps]) => {
        const rows = pl ? pl.items : null;
        const sum = k => (rows || []).reduce((a, r) => a + (Number(r[k]) || 0), 0);
        this.setState({
          prev: rows ? {
            cities: pl.pagination && Number(pl.pagination.count) ? Number(pl.pagination.count) : rows.length,
            sessions: sum("sessions"),
            conversions: sum("conversions"),
            markets: pp && pp.items ? pp.items.length : 0
          } : null,
          prevSeries: ps && ps.points ? ps : null
        });
      });
    } else this.setState({
      prev: null,
      prevSeries: null
    });
    const [l, p] = await Promise.all([safe(getLocations(this.props.range, "city", {
      top: 200
    })), safe(getPlaces(this.props.range, {
      top: 100
    }))]);
    // Cities = the server's row count for the range (the list itself is capped at 200).
    this.setState({
      locations: l ? l.items : null,
      places: p ? p.items : null,
      cities: l && l.pagination ? Number(l.pagination.count) || null : null
    });
  }
  render() {
    const {
      locations,
      places,
      cities,
      prev,
      prevSeries,
      geoSeries,
      marketSeries,
      mode,
      markets,
      hovered,
      q,
      country
    } = this.state;
    const {
      range
    } = this.props;
    const gs = geoSeries ? seriesRows(geoSeries) : [];
    const ms = marketSeries ? seriesRows(marketSeries) : [];
    const all = locations || [];
    const countries = Array.from(new Set(all.map(r => String(r.countryCode || "").toUpperCase()).filter(c => c.length === 2))).sort();
    const filtered = all.filter(r => (!q || `${r.city} ${r.regionCode} ${r.countryCode} ${r.postalCode}`.toLowerCase().includes(q.toLowerCase())) && (!country || String(r.countryCode || "").toUpperCase() === country));
    const rows = filtered.filter(r => r.lat && r.lng).map(r => ({
      lat: r.lat,
      lng: r.lng,
      label: `${r.city || r.postalCode || "?"}${r.regionCode ? ", " + r.regionCode : ""}`,
      sub: r.countryCode,
      value: Number(r.sessions) || Number(r.views) || 0
    }));
    const inUs = r => r.lng < -50 && r.lng > -170 && r.lat > 18 && r.lat < 72;
    const shown = mode === "us" ? rows.filter(inUs) : rows;
    // Label only the biggest bubbles; a dense metro cluster with every name on is unreadable.
    const labelled = shown.slice().sort((a, b) => b.value - a.value).slice(0, 12).map(r => r.label);
    const marketRows = markets ? (places || []).filter(r => r.lat && r.lng && (mode !== "us" || inUs(r))).map(r => ({
      lat: r.lat,
      lng: r.lng,
      label: r.name,
      sub: "market",
      value: Number(r.sessions) || 0,
      ring: true
    })) : [];
    const mapRows = shown.map(r => labelled.indexOf(r.label) >= 0 ? r : {
      ...r,
      quiet: true
    }).concat(marketRows);
    // World = sessions by country on the keyless country basemap (the bubble outline does not line up at world scale).
    const byCountry = {};
    filtered.forEach(r => {
      const c = String(r.countryCode || "").toUpperCase();
      if (c.length !== 2) return;
      byCountry[c] = (byCountry[c] || 0) + (Number(r.sessions) || Number(r.views) || 0);
    });
    const countryRows = Object.keys(byCountry).map(code => ({
      code,
      revenue: byCountry[code],
      orders: byCountry[code]
    })).sort((a, b) => b.revenue - a.revenue);
    const tot = (list, k) => (list || []).reduce((s, r) => s + (Number(r[k]) || 0), 0);
    const listRows = filtered.slice(0, 50);
    const miHref = m => `/MarketIntelligence/${range}?location=${encodeURIComponent(m.name || "")}`;
    return /*#__PURE__*/React.createElement("div", null, (() => {
      const partialNote = prevNote(prevSeries);
      const usePrev = prev && !partialNote;
      const comparing = prev === undefined || prevSeries === undefined ? undefined : !!usePrev;
      const d = (cur, k) => usePrev ? deltaOf(cur, prev[k]) : null;
      const geoSessions = tot(all, "sessions");
      const topCity = all.filter(r => mode !== "us" || String(r.countryCode || "").toUpperCase() === "US").sort((a, b) => (Number(b.sessions) || 0) - (Number(a.sessions) || 0))[0];
      const usShare = all.length ? Math.round(all.filter(r => String(r.countryCode || "").toUpperCase() === "US").reduce((a, r) => a + (Number(r.sessions) || 0), 0) / Math.max(1, geoSessions) * 100) : null;
      const tiles = [{
        l: "Cities",
        v: num(cities || all.length),
        d: d(cities || all.length, "cities"),
        s: countries.length ? `${countries.length} countries` : null,
        sp: gs.map(r => r.users)
      }, {
        l: "Sessions (geo-resolved)",
        v: num(geoSessions),
        d: d(geoSessions, "sessions"),
        s: usShare != null ? `${usShare}% in the US` : null,
        sp: gs.map(r => r.sessions)
      }, {
        l: "Markets with activity",
        v: num((places || []).length),
        d: d((places || []).length, "markets"),
        s: topCity ? `top ${mode === "us" ? "US " : ""}city ${topCity.city || topCity.postalCode}${topCity.regionCode ? ", " + topCity.regionCode : ""}${mode !== "us" && topCity.countryCode && String(topCity.countryCode).toUpperCase() !== "US" ? " · " + countryName(String(topCity.countryCode).toUpperCase()) : ""}` : null,
        sp: ms.map(r => r.sessions)
      }, {
        l: "Conversions",
        v: num(tot(all, "conversions")),
        d: d(tot(all, "conversions"), "conversions"),
        s: geoSessions ? `${pctOf(tot(all, "conversions"), geoSessions).toFixed(1)}% of geo sessions` : null,
        sp: gs.map(r => r.conversions)
      }];
      return /*#__PURE__*/React.createElement(Ribbon, {
        tiles: tiles,
        comparing: comparing,
        note: partialNote,
        loading: locations === undefined
      });
    })(), /*#__PURE__*/React.createElement("div", {
      className: "wa-grid"
    }, /*#__PURE__*/React.createElement(Card, {
      title: "Where they are",
      hint: mode === "us" ? "sessions by city · this range" : "sessions by country · this range"
    }, /*#__PURE__*/React.createElement("div", {
      className: "wa-toolbar"
    }, /*#__PURE__*/React.createElement("span", {
      className: "seg"
    }, /*#__PURE__*/React.createElement("button", {
      className: mode === "us" ? "on" : "",
      onClick: () => this.setState({
        mode: "us"
      })
    }, "US"), /*#__PURE__*/React.createElement("button", {
      className: mode === "world" ? "on" : "",
      onClick: () => this.setState({
        mode: "world"
      })
    }, "World")), mode === "us" ? /*#__PURE__*/React.createElement("button", {
      className: "wa-chip" + (markets ? " soft" : ""),
      onClick: () => this.setState({
        markets: !markets
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: "k"
    }, "Markets overlay"), " ", markets ? "on" : "off") : null, /*#__PURE__*/React.createElement("span", {
      className: "wa-filters"
    }, /*#__PURE__*/React.createElement(Search, {
      value: q,
      onChange: v => this.setState({
        q: v
      }),
      placeholder: "Search city, region, country"
    }), countries.length > 1 ? /*#__PURE__*/React.createElement(PlunkDropDown, {
      options: [["", "All countries"]].concat(countries.map(c => [c, countryName(c)])),
      value: country,
      onChange: v => this.setState({
        country: v
      }),
      width: "180px"
    }) : null, q || country ? /*#__PURE__*/React.createElement("button", {
      className: "wa-chip",
      onClick: () => this.setState({
        q: "",
        country: ""
      })
    }, "Clear filters") : null)), locations === undefined ? /*#__PURE__*/React.createElement(Pending, {
      h: 320
    }) : mode === "world" ? !countryRows.length ? /*#__PURE__*/React.createElement("div", {
      className: "wa-empty"
    }, "No sessions with a country in this range.") : /*#__PURE__*/React.createElement("div", {
      className: "wa-map"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GeoChoropleth, {
      scope: "world",
      rows: countryRows,
      metric: "revenue",
      labels: {
        revenue: "Sessions"
      },
      height: "360px",
      onSelect: code => this.setState({
        country: country === String(code).toUpperCase() ? "" : String(code).toUpperCase()
      })
    })), /*#__PURE__*/React.createElement(HBars, {
      rows: countryRows.slice(0, 10).map(r => ({
        name: countryName(r.code),
        value: r.revenue
      })),
      head: ["Country", "", "Sessions", ""],
      onClick: r => {
        const hit = countryRows.find(c => countryName(c.code) === r.name);
        if (hit) this.setState({
          country: hit.code
        });
      }
    })) : !shown.length ? /*#__PURE__*/React.createElement("div", {
      className: "wa-empty"
    }, "No geo-resolved US sessions match \xB7 try World.") : /*#__PURE__*/React.createElement("div", {
      className: "wa-map"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PostalBubbleMap, {
      rows: mapRows,
      hovered: hovered,
      onHover: l => this.setState({
        hovered: l
      }),
      height: 360,
      fill: true,
      showLabels: true
    })), /*#__PURE__*/React.createElement(HBars, {
      rows: shown.slice().sort((a, b) => b.value - a.value).slice(0, 10).map(r => ({
        name: r.label,
        value: r.value
      })),
      head: ["City", "", "Sessions", ""],
      onClick: r => this.setState({
        hovered: r.name
      })
    })), /*#__PURE__*/React.createElement("div", {
      className: "foot"
    }, "Geo comes from the tracker's IP resolution (about two thirds of sessions resolve). ", mode === "us" ? "Solid bubbles are cities (top 12 labelled); dashed rings are your markets. Click a country in World view to filter the list." : "Click a country to filter the list below.")), /*#__PURE__*/React.createElement(Card, {
      title: "Regions",
      hint: filtered.length > 50 ? `top 50 of ${num(filtered.length)} loaded · narrow with search or the country filter` : `${num(filtered.length)} cities`,
      span: 6
    }, locations === undefined ? /*#__PURE__*/React.createElement(Pending, null) : !listRows.length ? /*#__PURE__*/React.createElement("div", {
      className: "wa-empty"
    }, "No cities match.") : /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "City"), /*#__PURE__*/React.createElement("th", null, "Region"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Views"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Sessions"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Users"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Conv."))), /*#__PURE__*/React.createElement("tbody", null, listRows.map((r, i) => /*#__PURE__*/React.createElement("tr", {
      key: i,
      className: hovered && hovered.startsWith(r.city || "?") ? "on" : "",
      onMouseEnter: () => this.setState({
        hovered: `${r.city || r.postalCode || "?"}${r.regionCode ? ", " + r.regionCode : ""}`
      })
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("b", null, r.city || r.postalCode || "?")), /*#__PURE__*/React.createElement("td", {
      className: "dim"
    }, r.regionCode, r.countryCode && r.countryCode !== "US" ? ` · ${r.countryCode}` : ""), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.views)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.sessions)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.uniqueUsers)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.conversions)))))))), /*#__PURE__*/React.createElement(Card, {
      title: "Markets",
      hint: "your places \xB7 opens Market Intelligence",
      span: 6
    }, places === undefined ? /*#__PURE__*/React.createElement(Pending, null) : !places || !places.length ? /*#__PURE__*/React.createElement("div", {
      className: "wa-empty"
    }, "No market activity in this range \xB7 add markets under Manage Data \u203A Markets.") : /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Market"), /*#__PURE__*/React.createElement("th", null, "Ref"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Views"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Sessions"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Users"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Conv."))), /*#__PURE__*/React.createElement("tbody", null, places.slice(0, 50).map((r, i) => /*#__PURE__*/React.createElement("tr", {
      key: i
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
      to: miHref(r)
    }, /*#__PURE__*/React.createElement("b", null, r.name))), /*#__PURE__*/React.createElement("td", {
      className: "dim"
    }, r.referenceId), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.views)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.sessions)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.uniqueUsers)), /*#__PURE__*/React.createElement("td", {
      className: "n"
    }, num(r.conversions))))))))));
  }
}
const REGION_NAMES = (() => {
  try {
    return new Intl.DisplayNames(["en"], {
      type: "region"
    });
  } catch (e) {
    return null;
  }
})();
function countryName(code) {
  try {
    return REGION_NAMES && REGION_NAMES.of(code) || code;
  } catch (e) {
    return code;
  }
}

// The legacy Activity tab's Conversions / Interactions sections (KPI strip + by-name column chart)
// and its drill-down table. Names link to /Activity/Detail/{type}/{name}/{range} exactly as before.
function renderActivitySections(act, range) {
  if (act === undefined) return /*#__PURE__*/React.createElement(Card, {
    title: "Conversions and interactions"
  }, /*#__PURE__*/React.createElement(Pending, {
    h: 160
  }));
  if (!act) return null;
  const m = act.metrics || {};
  const conv = m.conversionMetrics || {};
  const eng = m.engagementMetrics || {};
  const strip = x => /*#__PURE__*/React.createElement("div", {
    className: "wa-minikpis"
  }, [["Total", num(x.total)], ["Users", num(x.users)], ["Sessions", num(x.sessions)], ["Value", Number(x.value) > 0 ? usd(x.value) : "—"]].map(([l, v]) => /*#__PURE__*/React.createElement("div", {
    key: l
  }, /*#__PURE__*/React.createElement("div", {
    className: "v"
  }, v), /*#__PURE__*/React.createElement("div", {
    className: "l"
  }, l))));
  const chart = (list, color, label) => {
    const rows = (list || []).filter(r => r && r.title);
    if (!rows.length) return /*#__PURE__*/React.createElement("div", {
      className: "wa-empty"
    }, "None in this range.");
    return /*#__PURE__*/React.createElement(ChartBoundary, null, /*#__PURE__*/React.createElement(Chart, {
      transitions: false,
      style: {
        height: 260
      }
    }, /*#__PURE__*/React.createElement(ChartCategoryAxis, null, /*#__PURE__*/React.createElement(ChartCategoryAxisItem, {
      categories: rows.map(r => r.title),
      labels: {
        font: "11px Proxima Nova, sans-serif",
        color: "#666",
        rotation: rows.length > 3 ? -40 : 0,
        content: e => {
          const t = String(e.value || "");
          return t.length > 22 ? t.slice(0, 21) + "…" : t;
        }
      },
      majorGridLines: {
        visible: false
      }
    })), /*#__PURE__*/React.createElement(ChartValueAxis, null, /*#__PURE__*/React.createElement(ChartValueAxisItem, _extends({
      labels: {
        format: "{0:n0}",
        font: "11px Proxima Nova, sans-serif",
        color: "#888"
      },
      majorGridLines: {
        color: "#eceff3"
      },
      line: {
        visible: false
      }
    }, countAxis(rows.map(r => Number(r.count) || 0))))), /*#__PURE__*/React.createElement(ChartSeries, null, /*#__PURE__*/React.createElement(ChartSeriesItem, {
      type: "column",
      data: rows.map(r => Number(r.count) || 0),
      name: label,
      color: color,
      gap: 1.4,
      labels: {
        visible: true,
        position: "top",
        font: "11px Proxima Nova, sans-serif",
        content: e => num(e.value)
      }
    })), /*#__PURE__*/React.createElement(ChartTooltip, {
      render: e => e && e.point ? `${e.point.category}: ${num(e.point.value)}` : ""
    })));
  };
  const rows = (act.rows || []).slice().sort((a, b) => (Number(b.total) || 0) - (Number(a.total) || 0));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    title: "Conversions",
    hint: "by name",
    span: 6
  }, strip(conv), chart(m.conversionList, "#ff6358", "Conversions")), /*#__PURE__*/React.createElement(Card, {
    title: "Interactions",
    hint: "by name",
    span: 6
  }, strip(eng), chart(m.engagementList, "#78d237", "Interactions")), /*#__PURE__*/React.createElement(Card, {
    title: "Conversions and interactions",
    hint: "click a name to drill down",
    right: /*#__PURE__*/React.createElement("a", {
      href: "#",
      onClick: e => {
        e.preventDefault();
        exportCsv(`/metrics/export/${range}`, `activity-${range}.csv`);
      }
    }, "Export CSV")
  }, !rows.length ? /*#__PURE__*/React.createElement("div", {
    className: "wa-empty"
  }, "No conversions or interactions in this range.") : /*#__PURE__*/React.createElement("div", {
    className: "tblwrap"
  }, /*#__PURE__*/React.createElement("table", {
    className: "territory-table wa-table"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Name"), /*#__PURE__*/React.createElement("th", null, "Type"), /*#__PURE__*/React.createElement("th", {
    className: "n"
  }, "Total"), /*#__PURE__*/React.createElement("th", {
    className: "n"
  }, "Users"), /*#__PURE__*/React.createElement("th", {
    className: "n"
  }, "Sessions"), /*#__PURE__*/React.createElement("th", {
    className: "n"
  }, "Value"))), /*#__PURE__*/React.createElement("tbody", null, rows.slice(0, 50).map((r, i) => /*#__PURE__*/React.createElement("tr", {
    key: i
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
    to: `/Activity/Detail/${r.type}/${String(r.title || "").replace(/ /g, "@")}/${range}`
  }, /*#__PURE__*/React.createElement("b", null, r.title || "—"))), /*#__PURE__*/React.createElement("td", {
    className: "dim"
  }, /engage|interact/i.test(r.type || "") ? "Interaction" : "Conversion"), /*#__PURE__*/React.createElement("td", {
    className: "n"
  }, num(r.total)), /*#__PURE__*/React.createElement("td", {
    className: "n"
  }, num(r.users)), /*#__PURE__*/React.createElement("td", {
    className: "n"
  }, num(r.sessions)), /*#__PURE__*/React.createElement("td", {
    className: "n"
  }, Number(r.value) > 0 ? usd(r.value) : "—"))))))));
}
export async function exportCsv(api, fileName) {
  try {
    const ServiceFactory = (await import("../../service")).default;
    const {
      AuthBase
    } = await import("../../../plunk/service/auth-base");
    const S = ServiceFactory.getType(api);
    const headers = {
      "x-app-id": S.account || ""
    };
    const jwt = AuthBase.idToken; // functions/authenticate has no idToken getter, so this export went out anonymous
    if (jwt) headers.Authorization = `Bearer ${jwt}`;
    const res = await fetch(S.rootEndpoint, {
      headers
    });
    const blob = await res.blob();
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = fileName;
    a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 2000);
  } catch (e) {/* export is best-effort */}
}